/**
 * Détection de mise à jour PWA : compare la version déployée (version.json) avec la version du bundle.
 * Si différente, recharge automatiquement la page pour appliquer la nouvelle version (sans bandeau ni clic).
 */
import React, { useEffect, useCallback } from 'react';
import toast from 'react-hot-toast';

const VERSION_URL = '/version.json';
const CHECK_INTERVAL_MS = 2 * 60 * 1000; // 2 minutes
const RELOAD_KEY = 'secura.pwaReloadFor';
const CURRENT_VERSION = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : null;

function PwaUpdatePrompt() {
  const checkVersion = useCallback(async () => {
    if (!CURRENT_VERSION) return;
    try {
      const res = await fetch(`${VERSION_URL}?t=${Date.now()}`, {
        cache: 'no-store',
        headers: { Pragma: 'no-cache', 'Cache-Control': 'no-cache' },
      });
      if (!res.ok) return;
      const data = await res.json();
      const serverVersion = data?.version;
      if (!serverVersion || serverVersion === CURRENT_VERSION) return;
      // Une seule tentative par version serveur : sinon un décalage de version.json recharge sans fin.
      let already = '';
      try { already = sessionStorage.getItem(RELOAD_KEY) || ''; } catch { /* stockage indisponible */ }
      if (already === String(serverVersion)) return;
      try { sessionStorage.setItem(RELOAD_KEY, String(serverVersion)); } catch { /* idem */ }
      toast.success('Mise à jour automatique en cours…', { duration: 1500 });
      setTimeout(() => window.location.reload(), 800);
    } catch {
      // Ignorer les erreurs (hors ligne, CORS, etc.)
    }
  }, []);

  useEffect(() => {
    checkVersion();
    const interval = setInterval(checkVersion, CHECK_INTERVAL_MS);
    const onFocus = () => checkVersion();
    const onVisible = () => {
      if (document.visibilityState === 'visible') checkVersion();
    };
    window.addEventListener('focus', onFocus);
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      clearInterval(interval);
      window.removeEventListener('focus', onFocus);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [checkVersion]);

  return null;
}

export default PwaUpdatePrompt;
